import { useMutation } from '@apollo/client';
import { Device } from '@/libs/onboarding/types';
import { UNPAIR_DEVICE } from '../queries/devices';
import { useCallback } from 'react';

interface DeviceUnpairRequestInput {
  deviceId: string;
}

interface DeviceUnpairResult {
  unpairDevice: boolean;
}

interface UseDeviceUnpairReturn {
  isDeviceUnpairing: boolean;
  unpairError: string | null;
  unpairDevice: (device: Device) => Promise<boolean>;
  clearError: () => void;
}

export const useDeviceUnpair = (): UseDeviceUnpairReturn => {
  const [mutate, unpairDeviceResponse] = useMutation<
    DeviceUnpairResult,
    DeviceUnpairRequestInput
  >(UNPAIR_DEVICE);

  const unpairDevice = useCallback(
    async (device: Device): Promise<boolean> => {
      try {
        const result = await mutate({ variables: { deviceId: device.id } });
        return result.data?.unpairDevice ?? false;
      } catch {
        return false;
      }
    },
    [mutate],
  );

  return {
    isDeviceUnpairing: unpairDeviceResponse.loading,
    unpairError: unpairDeviceResponse.error?.message || null,
    unpairDevice,
    clearError: unpairDeviceResponse.reset,
  };
};
